import React from "react";
import {Form, Message, Modal, Table} from "semantic-ui-react";
import userStore from "../stores/userStore";
import Button from "semantic-ui-react/dist/commonjs/elements/Button";
import {observable} from "mobx";
import {observer} from "mobx-react";
import {checkEdit, checkRole} from "../helper/rolehelper";
import Icon from "semantic-ui-react/dist/commonjs/elements/Icon";
import DatePicker from "react-datepicker";
import NumberFormat from "react-number-format";

const DEFAULT_ERROR = "Werte dürfen nicht 0, oder leer sein.";
const TYPE_ERROR = "Falsche Angabe : Art der Tanklieferung";
const LOCATION_ERROR = "Falsche Angabe : Ort wurde nicht angegeben oder Wert ist falsch";

@observer
export default class LiquidGasRow extends React.Component {

    @observable
    editLiquidgas = {
        liquidgasType: 1,
        date: new Date(),
        amountliter: 0,
        calorificvalue: 0,
        amountkWh: 0,
        costs: 0,
        proof: "",
        locationId: 0,
        id: 0,
        comment: ""
    };
    @observable
    error = false;

    @observable
    isEditModal = false;

    @observable
    addliquidgasModalOpen = false;

    @observable
    deleteModalOpen = false;

    @observable
    errorMessage = DEFAULT_ERROR;

    @observable privilegedUser = false;

    @observable edit = false;

    componentDidMount() {
    }


    constructor(props) {
        super(props);

        let user = userStore.userRolesFromServer;

        if (checkRole(user, "/liquidgas")) {
            this.privilegedUser = true;
        } else {
            this.privilegedUser = user.toString().includes("admin");
        }
        this.edit = checkEdit(user, "/liquidgas");
console.log(this.edit)
console.log(user)
        this.state = {
            open: false,
            deleteopen: false,
            delete: true,
            edit: true
        }
    }

    getLiquidGasName(type) {
        if (type === 1) {
            return "Tanklieferung";
        } else if (type === 2) {
            return "Tankkartenabrechnungen";
        } else if (type === 3) {
            return "FremdTankungen";
        } else {
            //todo:error
        }
    }

    //functions for edit
    checkInputValues() {
        console.log(this.editLiquidgas);
        //Check if vehicle has liquidgas and check if amounts are right
        if (this.editLiquidgas.length !== 0) {

            //Check if editHeatingoil has a valid type (1, 2 or 3)
            let type = (this.editLiquidgas.liquidgasType);
            if (type !== 1) {
                this.error = true;
                console.log(this.error);
                this.errorMessage = TYPE_ERROR;
                return;
            }

            //Check if location-Id has a valid type (not null, empty or undefined (valid = 1 - 7))
            let locationId = this.editLiquidgas.locationId;
            console.log(locationId);
            if (locationId === null || locationId === '' || locationId === undefined) {
                this.error = true;
                this.errorMessage = LOCATION_ERROR;
                return;
            }

            let amountliter = this.editLiquidgas.amountliter;
            let costs = this.editLiquidgas.costs;
            let proof = this.editLiquidgas.proof;
            if (amountliter === "" || costs === "" || amountliter === 0 || costs === "" || costs === 0 || proof === "") {
                this.error = true;
                this.errorMessage = DEFAULT_ERROR;
                console.log("value error");
                console.log(this.error);
                return;
            }
            this.setEdit();
        } else {
            this.error = true;
            console.log(this.error);
        }
    }

    setEdit() {
        console.log(this.editLiquidgas.date);

        this.props.editLiquidGas(this.editLiquidgas, (this.editLiquidgas.liquidgasType));

        this.closeInput()
    }


    openEditLiquidGasModal() {
        this.editLiquidgas.liquidgasType = this.props.liquidgas.liquidgasType;
        this.editLiquidgas.date = new Date(this.props.liquidgas.date * 1000);
        this.editLiquidgas.amountliter = this.props.liquidgas.amountliter;
        this.editLiquidgas.calorificvalue = this.props.liquidgas.calorificvalue;
        this.editLiquidgas.amountkWh = this.props.liquidgas.amountkWh;
        this.editLiquidgas.costs = this.props.liquidgas.costs;
        this.editLiquidgas.proof = this.props.liquidgas.proof;
        this.editLiquidgas.comment = this.props.liquidgas.comment;
        this.editLiquidgas.locationId = this.props.locationId;
        this.editLiquidgas.id = this.props.liquidgas.id;
    }

    handleChange(date) {
        if (date === null) {
            this.setState({
                ...this.state,
                error: true
            })
        } else {
            this.editLiquidgas.date = date;
        }
    }


    getTypeId(name) {
        if (name === "Tanklieferung") {
            return 1;
        } else if (name === "Tankkarte") {
            return 2;
        } else {
            return 3;
        }
    }

    closeInput() {

        this.isEditModal = false;
        this.addliquidgasModalOpen = false;
        this.state.open = false;
        this.deleteModalOpen = false;
        this.editLiquidgas = {
            liquidgasType: this.props.liquidgas.liquidgasType,
            date: new Date(this.props.liquidgas.date * 1000),
            amountliter: this.props.liquidgas.amountliter,
            calorificvalue: this.props.liquidgas.calorificvalue,
            amountkWh: this.props.liquidgas.amountkWh,
            costs: this.props.liquidgas.costs,
            proof: this.props.liquidgas.proof,
            locationId: this.props.locationId,
            comment: this.props.liquidgas.comment,
            id: this.props.liquidgas.id
        };

        this.error = false;
    }


    handleInputChange(type, event, data) {
        this.editLiquidgas.calorificvalue = 6.57;

        this.editLiquidgas.amountkWh = this.editLiquidgas.amountliter * this.editLiquidgas.calorificvalue;
        if (type === 'liquidgasType') {
            this.editLiquidgas.liquidgasType = data.value;
        } else if (type === 'date') {
            this.editLiquidgas.date = data.value;
        } else if (type === 'date') {
            this.editLiquidgas.date = data.value;
        } else if (type === 'costs') {
            if (data.value === "") {
                this.editLiquidgas.costs = 0;
            } else
                this.editLiquidgas.costs = data.value;
        } else if (type === 'amountliter') {
            if (data.value === "") {
                this.editLiquidgas.amountliter = 0;
            } else {
                this.editLiquidgas.amountliter = data.value;
            }
        } else if (type === 'proof') {
            this.editLiquidgas.proof = data.value;
        } else if (type === 'comment') {
            this.editLiquidgas.comment = data.value;
        }
        this.editLiquidgas.locationId = this.props.locationId;
    }

    //functions for edit


    //functions for delete


    openDeleteLiquidGasModal(liquidgasesId) {
        this.deleteModalOpen = true;
        console.log(this.props.liquidgas)
        this.props.deleteLiquidGas(liquidgasesId);
        this.closeDeleteInput();
    }


    closeDeleteInput() {
        this.addliquidgasModalOpen = false;
        this.isEditModal = false;
        this.state.deleteopen = false;
        this.deleteModalOpen = false;
        this.editLiquidgas = {
            liquidgasType: 1,
            date: new Date(),
            amountliter: "",
            calorificvalue: "",
            amountkWh: "",
            costs: "",
            proof: "",
            comment: ""
        };
        console.log(this.state.deleteopen);
        this.error = false;
    }

    //functions for delete


    getTypeId(name) {
        if (name === "Tanklieferung") {
            return 1;
        } else if (name === "Tankkarte") {
            return 2;
        } else {
            return 3;
        }
    }

    render() {
        const IdOptions = [
            {key: 4, text: 'Tanklieferung', value: 1},
            {key: 5, text: 'Tankkarte', value: 2},
            {key: 6, text: 'Fremdtankung', value: 3}
        ];
        const calorificvalue = 6.57;

        return (

            <Table.Row className="color-sub-row">
                <Table.Cell/>
                {this.edit ?
                    <Table.Cell>
                        <Modal open={this.state.deleteopen} className={"modal-top"}
                               onClose={this.closeDeleteInput.bind(this)} centered={false}
                               trigger={this.delete ?
                                   <Icon name='delete' color="red"
                                         onClick={() => this.setState({deleteopen: true, delete: true})}/>
                                   :
                                   <Icon name='delete' color="red"
                                         onClick={() => this.setState({deleteopen: true, delete: true})}/>
                               }>
                            <Modal.Header>Löschen</Modal.Header>
                            <Modal.Content>
                                Sicher löschen?
                            </Modal.Content>
                            <Modal.Actions>
                                <Button negative icon='delete' onClick={this.closeDeleteInput.bind(this)}/>
                                <Button
                                    positive
                                    icon='checkmark'
                                    onClick={this.openDeleteLiquidGasModal.bind(this, this.props.liquidgas.id)}

                                />
                            </Modal.Actions>
                        </Modal>
                    </Table.Cell>
                    :
                    null
                }
                {this.edit ?
                    <Table.Cell>
                        <Modal centered={false} className={"modal-top"} open={this.state.open} size="small"
                               trigger={
                                   <Icon name='edit' color="green"
                                         onClick={() => {
                                             this.openEditLiquidGasModal();
                                             this.setState({open: true, edit: true});
                                         }}/>
                               }>
                            <Modal.Header>{this.isEditModal ? "Bearbeiten" : "Hinzufügen"}</Modal.Header>
                            <Modal.Content>
                                <Form error={this.error}>
                                    <Form.Group widths='equal'>


                                        <Form.Field>
                                            <label>Datum</label>

                                            <DatePicker
                                                selected={this.editLiquidgas.date}
                                                onChange={this.handleChange.bind(this)}
                                                dateFormat="dd.MM.yyyy"
                                            />
                                        </Form.Field>
                                    </Form.Group>
                                    <Form.Group widths='equal'>
                                        <Form.Field>
                                            <label>Menge [l]</label>
                                            <NumberFormat value={parseFloat(this.editLiquidgas.amountliter)}
                                                          thousandSeparator="."
                                                          decimalSeparator=","
                                                          decimalScale={2}
                                                          onValueChange={(values, e) => {
                                                              this.handleInputChange('amountliter', null, {value: values.floatValue})
                                                          }}
                                                          allowNegative={false}
                                                          suffix=" l"/>
                                        </Form.Field>
                                        <Form.Field>
                                            <label>Heizwert</label>
                                            {calorificvalue}
                                        </Form.Field>
                                        <Form.Field>
                                            <label>kWh</label>
                                            {Math.round(this.editLiquidgas.amountliter * calorificvalue * 100) / 100}
                                        </Form.Field>
                                        <Form.Field>
                                            <label>Kosten [€]</label>
                                            <NumberFormat value={parseFloat(this.editLiquidgas.costs)}
                                                          thousandSeparator="."
                                                          decimalSeparator=","
                                                          decimalScale={2}
                                                          onValueChange={(values, e) => {
                                                              this.handleInputChange('costs', null, {value: values.floatValue})
                                                          }}
                                                          allowNegative={false}
                                                          suffix=" €"/>
                                        </Form.Field>
                                    </Form.Group>
                                    <Form.Group widths='equal'>
                                        <Form.Field>
                                            <label>Nachweis</label>
                                            <Form.Input value={this.editLiquidgas.proof}
                                                        type='proof'
                                                        onChange={this.handleInputChange.bind(this, 'proof')}/>
                                        </Form.Field>
                                        <Form.Field>
                                            <label>Bemerkung</label>
                                            <Form.Input value={this.editLiquidgas.comment}
                                                        type='comment'
                                                        onChange={this.handleInputChange.bind(this, 'comment')}/>
                                        </Form.Field>

                                    </Form.Group>
                                    <Message
                                        error
                                        header='Fehler'
                                        content={this.errorMessage}
                                    />
                                </Form>
                            </Modal.Content>
                            <Modal.Actions>
                                <Button negative icon='delete' onClick={this.closeInput.bind(this)}/>
                                <Button
                                    positive
                                    icon='checkmark'
                                    onClick={() => this.checkInputValues()}
                                />
                            </Modal.Actions>
                        </Modal>
                    </Table.Cell>
                    :
                    null
                }
                <Table.Cell>
                    {new Date(this.props.liquidgas.date * 1000).toLocaleDateString()}
                </Table.Cell>
                <Table.Cell>
                    {new Intl.NumberFormat('de-DE', {style: 'decimal'}).format(this.props.liquidgas.amountliter.toFixed(2))}
                </Table.Cell>
                <Table.Cell>
                    {new Intl.NumberFormat('de-DE', {style: 'decimal'}).format(this.props.liquidgas.calorificvalue)}
                </Table.Cell>
                <Table.Cell>
                    {new Intl.NumberFormat('de-DE', {style: 'decimal'}).format(this.props.liquidgas.amountkWh.toFixed(2))}
                </Table.Cell>
                <Table.Cell>
                    {new Intl.NumberFormat('de-DE', {
                        style: 'currency',
                        currency: 'EUR'
                    }).format(this.props.liquidgas.costs.toFixed(2))}
                </Table.Cell>
                <Table.Cell>
                    {this.props.liquidgas.comment}
                </Table.Cell>
                <Table.Cell>
                    {this.props.liquidgas.proof}
                </Table.Cell>
            </Table.Row>
        );
    }
}